import { useState } from 'react';
import LicenseData from '../components/LicenseData';
import API_ROOT from '../config';
import { useFetch } from './Launchpad';
import { PrimaryButton, SecondaryButton } from '../components/Button';
import Accordion from '../components/Accordion';

function Lookup({ tenant, onDone }) {
  const [serialNo, setSerialNo] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [results, setResults] = useState([]);

  const { fetchWithAuth } = useFetch();
  const lookup = async () => {

    const response = await fetchWithAuth(`${API_ROOT}/v1/license/${tenant}/${serialNo}?history=true`);
    if (response.status === 404) {
      setMessage('License not found.');
      setResults([]);
      return;
    }
    if (!response.ok) {
      let errorText = await response.text();
      const errorPrefix = 'Unable to lookup license: ';
      try {
        let errorData = JSON.parse(errorText);
        setError(errorPrefix + (errorData.Message ?? ""));
      }
      catch (e) {
        setError(errorPrefix + errorText);
      }
      console.error(errorPrefix, response);
      return;
    }
    const resultsData = await response.json();
    setResults(resultsData);
  }

  const clear = () => {
    setSerialNo('');
    setMessage('');
    setResults([]);
    setError('');
  }

  return (
    <div>
      Use this page to lookup a license

      <input
        type="text"
        value={serialNo}
        onChange={(e) => setSerialNo(e.target.value)}
        placeholder="Enter serial number" />

      <div>{message}</div>
      <div>{error}</div>

      <Accordion>
        {results.map((result, index) => (
          { header: `License ${index + 1}`, body: <LicenseData data={result} /> }
        ))}
      </Accordion>

      {
        !message
          ? <PrimaryButton disabled={!serialNo} onClick={lookup}>Lookup</PrimaryButton>
          : <SecondaryButton onClick={clear}>Lookup another EGM</SecondaryButton>
      }

      <SecondaryButton onClick={onDone}>{message ? "Done" : "Cancel"}</SecondaryButton>
    </div>
  );
}

export default Lookup;